<form [formGroup]="formGroup">
	<ngx-intl-tel-input
		[cssClass]="cssClass"
		[class.is-invalid]="control.invalid && control.touched"
		[id]="name"
		[preferredCountries]="[CountryISO.SouthAfrica]"
		[enableAutoCountrySelect]="true"
		[enablePlaceholder]="true"
		[searchCountryFlag]="true"
		[searchCountryField]="[SearchCountryField.All]"
		[selectFirstCountry]="true"
		[phoneValidation]="true"
		[separateDialCode]="true"
		[numberFormat]="PhoneNumberFormat.International"
		[formControlName]="name"
	>
	</ngx-intl-tel-input>

	<div *ngIf="control.invalid && control.errors" class="invalid-feedback">
		<p *ngIf="control.errors?.required">Phone number is required.</p>
		<p *ngIf="control.errors?.validatePhoneNumber?.valid === false">Phone number is invalid.</p>
		<p *ngIf="control.errors?.misMatch">{{ control.errors.misMatch }}</p>
		<p *ngIf="control.errors?.minlength">Phone number must be at least {{ control.errors.minlength.requiredLength }} characters.</p>
		<p *ngIf="control.errors?.maxlength">Phone number must be less than {{ control.errors.maxlength.requiredLength }} characters.</p>
	</div>
</form>
